import { Outlet } from 'react-router-dom';

import AppContainer from './AppContainer';

export default function Template({ children }) {
  return <AppContainer>{children || <Outlet />}</AppContainer>;
}
